<template>
  <div class="flex items-center">
    <button
      class="mr-2"
      :disabled="selectedPage === 1"
      @click="onClickFirstPage"
    >
      <img
        :class="selectedPage === 1 ? 'cursor-default opacity-50' : ''"
        class="-top-2px relative w-full rotate-180 transform"
        src="@/assets/icon-last.svg"
        alt=""
      />
    </button>
    <button
      class="mr-2"
      :disabled="selectedPage === 1"
      @click="onClickBack"
    >
      <img
        :class="selectedPage === 1 ? 'cursor-default opacity-50' : ''"
        class="-top-2px relative w-full rotate-180 transform"
        src="@/assets/icon-next.svg"
        alt=""
      />
    </button>
    <span
      v-for="page in shownPages"
      :key="'page_' + page"
      class="mr-2 cursor-pointer rounded px-3 py-2"
      :class="
        page === selectedPage ? 'bg-yellow-500 text-white' : 'text-body-color'
      "
      @click="onClickPage(page)"
    >
      {{ page }}
    </span>
    <button
      :disabled="selectedPage === totalPages"
      class="mr-2"
      @click="onClickNext"
    >
      <img
        :class="selectedPage === totalPages ? 'cursor-default opacity-50' : ''"
        class="-top-2px relative w-full"
        src="@/assets/icon-next.svg"
        alt=""
      />
    </button>
    <button
      class="mr-2"
      :disabled="selectedPage === totalPages"
      @click="onClickLastPage"
    >
      <img
        :class="selectedPage === totalPages ? 'cursor-default opacity-50' : ''"
        class="-top-2px relative w-full"
        src="@/assets/icon-last.svg"
        alt=""
      />
    </button>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  props: {
    selectedPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    pagesAround: {
      type: Number,
      default: 1,
    },
    equivalent: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const shownPages = computed(() => {
      let low = Math.max(1, props.selectedPage - props.pagesAround);
      let high = Math.min(
        props.selectedPage + props.pagesAround,
        props.totalPages
      );

      // You need the possibility to always keep five options, with a page around on 2 would work for example,
      // when 3 is selected you will have: 1 2 3 4 5 (two on the left, two on the right).
      // In this same case, you have a problem when the selected page is 2 or 1. Because if the page around is 2,
      // then for 2 you would have 1 2 3 3 4 (here the condition that 5 are needed is not fulfilled.

      // Requirements:
      // - You need to use the prop equivalent as true.

      if (props.equivalent) {
        if (props.selectedPage === 1 || props.selectedPage === 2) {
          if (props.totalPages > 5) {
            low = 1;
            high = 5;
          }
        }
      }

      const numbers = [];

      for (let i = low; i <= high; i++) {
        numbers.push(i);
      }

      return numbers;
    });

    const onClickPage = (newPage) => {
      emit('selectPage', newPage);
    };

    const onClickNext = () => {
      if (props.selectedPage + 1 > props.totalPages) {
        return;
      }
      emit('selectPage', props.selectedPage + 1);
    };

    const onClickBack = () => {
      if (props.selectedPage - 1 <= 0) {
        return;
      }
      emit('selectPage', props.selectedPage - 1);
    };

    const onClickFirstPage = () => {
      emit('selectPage', 1);
    };

    const onClickLastPage = () => {
      emit('selectPage', props.totalPages);
    };

    return {
      shownPages,
      onClickPage,
      onClickNext,
      onClickBack,
      onClickFirstPage,
      onClickLastPage,
    };
  },
};
</script>
